function sendGaEvent(product, quantity, eventName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  const ecommerceData = {
    event: eventName,
    ecommerce: {
      currency: "USD",
      value:
        quantity > 0
          ? ((quantity * product.price) / 100).toFixed(2)
          : ((product.quantity * product.price) / 100).toFixed(2),
      items: [
        {
          item_id: product.id,
          item_name: product.title || "",
          item_brand: product.vendor || "",
          item_category: product.type || "",
          item_variant: product.variant_title || "",
          price: (product.price / 100).toFixed(2),
          quantity: quantity > 0 ? quantity : product.quantity,
        },
      ],
    },
  };
  if (eventName === "select_item") {
    ecommerceData.ecommerce.item_list_id = "";
    ecommerceData.ecommerce.item_list_name = "";
    ecommerceData.ecommerce.items[0].index = product.index || 0;
  }
  window.dataLayer.push(ecommerceData);
}
function sendGaEventCartPage(eventName, cartData) {
  const items = cartData.items.map((item) => {
    return {
      item_id: item.id,
      item_name: item.product_title || "",
      item_brand: item.vendor || "",
      item_category: item.type || "",
      item_variant: item.product_title || "",
      price: (item.final_price / 100).toFixed(2),
      quantity: item.quantity || 0,
    };
  });
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: eventName,
    ecommerce: {
      currency: "USD",
      value: (cartData.total_price / 100).toFixed(2),
      items: items,
    },
  });
}
